import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { RouterOutlet } from '@angular/router';

@Component({
    imports: [
        RouterOutlet,
        HeaderComponent,
        FooterComponent,
    ],
    templateUrl: './page-shell.component.html',
    styleUrls: ['./page-shell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageShellComponent {}
